import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import InvoiceView from '../views/invoice/InvoiceView.vue'
import InvoiceBacklogView from "../views/invoice/InvoiceBacklogView";
import InvoiceLinkedView from "@/views/invoice/InvoiceLinkedView";
import InvoiceDoneView from "@/views/invoice/InvoiceDoneView";
import InvoiceIssueView from "@/views/invoice/InvoiceIssueView";
import InvoiceTimelineView from "@/views/invoice/InvoiceTimelineView";
import InvoiceDeletedView from "@/views/invoice/InvoiceDeletedView";
import TransactionView from "@/views/transaction/TransactionView";
import TransactionLinkedView from "@/views/transaction/TransactionLinkedView";
import TransactionBacklogView from "@/views/transaction/TransactionBacklogView";
import TransactionDeletedView from "@/views/transaction/TransactionDeletedView";
import TransactionStatusView from "@/views/transaction/TransactionStatusView";
import TransactionSingleView from "@/views/transaction/TransactionSingleView";
import InvoiceSingleView from "@/views/invoice/InvoiceSingleView";
import CompanySingleView from "@/views/company/CompanySingleView";
import ProfileSingleView from "@/views/profile/ProfileSingleView";
import CompanyView from "@/views/company/CompanyView";
import PageNotFound from "@/views/PageNotFound";
import LoginView from "@/views/LoginView";
import {authGuard} from "@/auth";


import InvoiceExportView from "@/views/invoice/InvoiceExportView";
import GlobalTransactionAllView from "@/views/global_transaction/GlobalTransactionAllView.vue";
import GlobalTransactionXmoneyView from "@/views/global_transaction/GlobalTransactionXmoneyView.vue";
import GlobalTransactionNowpaymentsView from "@/views/global_transaction/GlobalTransactionNowpaymentsView.vue";
import GlobalTransactionDedipassView from "@/views/global_transaction/GlobalTransactionDedipassView.vue";
import GlobalTransactionStripeView from "@/views/global_transaction/GlobalTransactionStripeView.vue";
import GlobalTransactionPaypalView from "@/views/global_transaction/GlobalTransactionPaypalView.vue";
import GlobalTransactionEnterpriseEuropeView
    from "@/views/global_transaction/GlobalTransactionEnterpriseEuropeView.vue";
import GlobalTransactionExceptEuropeView from "@/views/global_transaction/GlobalTransactionExceptEuropeView.vue";
import GlobalTransactionDayView from "@/views/global_transaction/GlobalTransactionDayView.vue";
import AccountSummaryView from "@/views/account/AccountSummaryView.vue";
import TicketListView from "@/views/support/TicketListView.vue";
import TicketDetailView from "@/views/support/TicketDetailView.vue";

const title = "Clafoutis"

const routes = [
    {
        path: '/profile',
        name: 'ProfileSingleView',
        beforeEnter: authGuard,
        component: ProfileSingleView,
        props: true,
        meta: {
            title: `Profile`
        }
    },
    {
        path: '/board',
        name: 'Board',
        beforeEnter: authGuard,
        component: () => import('../views/board/BoardView.vue'),
        meta: {
            title: `Board`
        }
    },
    {
        path: '/inventory',
        name: 'Inventory',
        beforeEnter: authGuard,
        component: () => import('../views/inventory/InventoryView.vue'),
        meta: {
            title: `Inventaire - ${title}`
        }
    },
    {
        path: '/tva',
        name: 'TVA',
        beforeEnter: authGuard,
        component: () => import('../views/accounting/VatView.vue'),
        meta: {
            title: `TVA - ${title}`
        }
    },
    {
        path: '/pilotage',
        name: 'Pilotage',
        beforeEnter: authGuard,
        component: () => import('../views/accounting/PilotageView.vue'),
        meta: {
            title: `Pilotage - ${title}`
        }
    },
    {
        path: '/tresorerie',
        name: 'Trésorerie',
        beforeEnter: authGuard,
        component: () => import('../views/accounting/CashFlowView.vue'),
        meta: {
            title: `Trésorerie - ${title}`
        }
    },
    {
        path: '/comparatif-comptable',
        name: 'Comparatif comptable',
        beforeEnter: authGuard,
        component: () => import('../views/accounting/AccountingCompareView.vue'),
        meta: {
            title: `Comparatif comptable - ${title}`
        }
    },
    {
        path: '/journaux',
        name: 'Journaux',
        beforeEnter: authGuard,
        component: () => import('../views/accounting/JournalsView.vue'),
        meta: {
            title: `Journaux - ${title}`
        }
    },
    {
        path: '/grand-livre',
        name: 'Grand livre',
        beforeEnter: authGuard,
        component: () => import('../views/accounting/LedgerView.vue'),
        meta: {
            title: `Grand livre - ${title}`
        }
    },
    {
        path: '/balance',
        name: 'Balance',
        beforeEnter: authGuard,
        component: () => import('../views/accounting/BalanceView.vue'),
        meta: {
            title: `Balance - ${title}`
        }
    },
    {
        path: '/',
        name: 'Dashboard',
        beforeEnter: authGuard,
        component: HomeView,
        meta: {
            title: `Dashboard`
        }
    },
    {
        path: '/global_transaction',
        name: 'Rapports - Transactions Clients',
        beforeEnter: authGuard,
        component: () => import('../views/global_transaction/GlobalTransactionReportsView.vue'),
        meta: {
            title: `Rapports - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/all',
        name: 'Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionAllView,
        meta: {
            title: `Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/paypal',
        name: 'Paypal - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionPaypalView,
        meta: {
            title: `Paypal - Transactions Clients - ${title}`
        }
    },

    {
        path: '/global_transaction/stripe',
        name: 'Stripe - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionStripeView,
        meta: {
            title: `Stripe - Transactions Clients - ${title}`
        }
    },

    {
        path: '/global_transaction/dedipass',
        name: 'Dedipass - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionDedipassView,
        meta: {
            title: `Dedipass - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/xmoney',
        name: 'xMoney - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionXmoneyView,
        meta: {
            title: `xMoney - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/nowpayments',
        name: 'Nowpayments - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionNowpaymentsView,
        meta: {
            title: `Nowpayments - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/bitpay',
        name: 'Bitpay - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionStripeView,
        meta: {
            title: `Bitpay - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/enterprise_europe',
        name: 'Entreprise Europe - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionEnterpriseEuropeView,
        meta: {
            title: `Entreprise Europe - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/except_europe',
        name: 'Hors Europe - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionExceptEuropeView,
        meta: {
            title: `Hors Europe - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/day/:date',
        name: 'Journalier - Transactions Clients',
        beforeEnter: authGuard,
        component: GlobalTransactionDayView,
        props: true,
        meta: {
            title: `Journalier - Transactions Clients - ${title}`
        }
    },
    {
        path: '/global_transaction/month/:month?',
        name: 'Vue mensuelle - Transactions Clients',
        beforeEnter: authGuard,
        component: () => import("@/views/global_transaction/GlobalTransactionMonthView.vue"),
        props: true,
        meta: {
            title: `Vue mensuelle - Transactions Clients - ${title}`
        }
    },
    {
        path: '/transaction/:id',
        name: 'TransactionSingleView',
        beforeEnter: authGuard,
        component: TransactionSingleView,
        props: true,
        meta: {
            title: `Transaction - ${title}`
        }
    },
    {
        path: '/transaction',
        name: 'transaction',
        beforeEnter: authGuard,
        component: TransactionView,
        meta: {
            title: `Transactions - ${title}`
        }
    },
    {
        path: '/transaction/backlog',
        name: 'transaction backlog',
        beforeEnter: authGuard,
        component: TransactionBacklogView,
        meta: {
            title: `En attente - Transactions - ${title}`
        }
    },
    {
        path: '/transaction/linked',
        name: 'transaction linked',
        beforeEnter: authGuard,
        component: TransactionLinkedView,
        meta: {
            title: `Associée - Transactions - ${title}`
        }
    }, {
        path: '/transaction/deleted',
        name: 'transaction deleted',
        beforeEnter: authGuard,
        component: TransactionDeletedView,
        meta: {
            title: `Supprimée - Transactions - ${title}`
        }
    },
    {
        path: '/transaction/status/:status',
        name: 'transaction status',
        beforeEnter: authGuard,
        component: TransactionStatusView,
        meta: {
            title: `Statut - Transactions - ${title}`
        }
    },
    {
        path: '/invoice',
        name: 'invoice',
        beforeEnter: authGuard,
        component: InvoiceView,
        meta: {
            title: `Factures - ${title}`
        }
    },
    {
        path: '/invoice/backlog',
        name: 'invoice backlog',
        beforeEnter: authGuard,
        component: InvoiceBacklogView,
        meta: {
            title: `En attente - Factures - ${title}`
        }
    },
    {
        path: '/invoice/linked',
        name: 'invoice linked',
        beforeEnter: authGuard,
        component: InvoiceLinkedView,
        meta: {
            title: `Associée - Factures - ${title}`
        }
    },
    {
        path: '/invoice/done',
        name: 'invoice done',
        beforeEnter: authGuard,
        component: InvoiceDoneView,
        meta: {
            title: `Traitée - Factures - ${title}`
        }
    },
    {
        path: '/invoice/issue',
        name: 'invoice issue',
        beforeEnter: authGuard,
        component: InvoiceIssueView,
        meta: {
            title: `Problème - Factures - ${title}`
        }
    },
    {
        path: '/invoice/timeline',
        name: 'invoice timeline',
        beforeEnter: authGuard,
        component: InvoiceTimelineView,
        meta: {
            title: `Echéancier - Factures - ${title}`
        }
    },
    {
        path: '/invoice/deleted',
        name: 'invoice deleted',
        beforeEnter: authGuard,
        component: InvoiceDeletedView,
        meta: {
            title: `Supprimée - Factures - ${title}`
        }
    },
    {
        path: '/invoice/export',
        name: 'invoice export',
        beforeEnter: authGuard,
        component: InvoiceExportView,
        meta: {
            title: `Export PDF - Factures - ${title}`
        }
    },
    {
        path: '/invoice/:id',
        name: 'InvoiceSingleView',
        beforeEnter: authGuard,
        component: InvoiceSingleView,
        props: true,
        meta: {
            title: `Facture - ${title}`
        }
    },
    {
        path: '/file/:id',
        name: 'FileSingleView',
        beforeEnter: authGuard,
        component: InvoiceSingleView,
        props: true,
        meta: {
            title: `Facture - ${title}`
        }
    },
    {
        path: '/company',
        name: 'company list',
        beforeEnter: authGuard,
        component: CompanyView,
        meta: {
            title: `Fournisseurs - ${title}`
        }
    },
    {
        path: '/company/:id',
        name: 'CompanySingleView',
        beforeEnter: authGuard,
        component: CompanySingleView,
        props: true,
        meta: {
            title: `Fournisseur - ${title}`
        }
    },
    {
        path: '/account/summary',
        name: 'AccountSummaryView',
        beforeEnter: authGuard,
        component: AccountSummaryView,
        meta: {
            title: `Comptes comptables - ${title}`
        }
    },
    {
        path: '/support/tickets',
        name: 'TicketListView',
        beforeEnter: authGuard,
        component: TicketListView,
        meta: {
            title: `Tickets Support - ${title}`
        }
    },
    {
        path: '/support/tickets/:id',
        name: 'TicketDetailView',
        beforeEnter: authGuard,
        component: TicketDetailView,
        props: true,
        meta: {
            title: `Ticket - ${title}`
        }
    },
    {
        path: '/login',
        name: 'LoginView',
        component: LoginView,
        props: true,
        meta: {
            title: `Login`
        }
    },
    {
        path: '/about',
        name: 'about',
        beforeEnter: authGuard,
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/:pathMatch(.*)',
        name: 'PageNotFound',
        component: PageNotFound,
        props: true,
        meta: {
            title: `Error 404 - ${title}`
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
    // `/nested`'s will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    } else if (previousNearestWithMeta) {
        document.title = previousNearestWithMeta.meta.title;
    }

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    next();
});


export default router
